import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { OriginalSegment } from 'src/app/core/models/fare-family.model';

@Component({
  selector: 'app-comparison-per-flight',
  templateUrl: './comparison-per-flight.component.html',
  styleUrls: ['./comparison-per-flight.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ComparisonPerFlightComponent {
  @Input() original: OriginalSegment[];
  @Input() alternative: any[];
}
